import { createResourceHandler } from './createResourceHandler'
import { fetchEmailData } from './fetchEmailData'
import { updateResourceHandler } from './updateResourceHandler'

export const methods = {
  createResource: createResourceHandler,
  fetchDataHandler: fetchEmailData,
  updateResource: updateResourceHandler,
}
